import * as iris from '@frontend/iris';
import { EnvName } from '@frontend/iris/dist/types/config';
import { config } from './config';
import { getSensorsData } from '@/utils/sensors';

const LANDPAGE_PID = '4ceH5ekc';
const PRODUCT_CODE = 'landpage';

const irisEnv:Record<string, EnvName> = {
  local: 'api-test',
  development: 'dev',
  test: 'api-test',
  staging: 'staging',
  production: 'prod',
};

let inited = false;

// 初始化iris
export const initIris = ():typeof iris => {
  if (!inited) {
    iris.init({
      env: irisEnv[config.env],
      domain: '',
      custom_headers: {
        'SENSORS-DATA': getSensorsData(),
      },
    });
    inited = true;
  }

  return iris;
};

// 平台授权接口
export const CodemaoAuth:CodemaoAuth = iris.auth.init({
  appid: '',
  // 产品id
  pid: LANDPAGE_PID,
  // 产品代号，用于数据平台分析
  product_code: PRODUCT_CODE,
  // 平台，当前业务的适用平台，用于数据平台分析
  platform: 'h5',
});


// 初始化
const initCodemaoCaptcha = ():iris.captcha.CodemaoCaptcha =>
  new iris.captcha.CodemaoCaptcha({
    pid: LANDPAGE_PID, // 项目pid
  });

export const showCaptcha = (identity = ''):Promise<{ ticket:string; appid:string }> => {
  if (!inited) {
    throw new Error('iris not inited');
  }

  return new Promise((resolve, reject) => {
    initCodemaoCaptcha()
      .get_captcha({
        identity: identity,
        // 腾讯验证码初始化必须要置入图形验证码的dom元素id
        // 降级后极验配置项 product 为 bind 的时候，则设置为 button 的id
        // 验证成功后的回调 回调函数可以包含ticket参数，ticket是验证成功后
        // 后端返回的一个字符串 可用于发送短信验证码等操作
        success_callback: (ticket, appid) => {
          resolve({
            ticket,
            appid,
          });
        },
        // 验证失败后的回调
        fail_callback: reject,
        // 用户主动关闭图形验证码后的回调
        close_callback: reject,
        // 为极验提供了额外的选项
        // 只对极验图形验证码生效！！
        // 其默认配置为{ product:'popup', width:'300px' }
      })
      .then((captcha) => {
        captcha?.init().then(() => {
          captcha.show();
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};
